import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

let MERGE_TAGS = /** @type {const} */ ({
  appointment_bookings_state_update: [
    {
      text: 'Patient first name',
      type: 'menuitem',
      value: '{{patient.firstName}}',
    },
    {
      text: 'Patient last name',
      type: 'menuitem',
      value: '{{patient.lastName}}',
    },
    {
      text: 'Appointment date',
      type: 'menuitem',
      value: '{{appointment.date}}',
    },
    {
      text: 'Appointment time',
      type: 'menuitem',
      value: '{{appointment.time}}',
    },
    {
      text: 'Confirmation link',
      type: 'menuitem',
      value: '{{appointment.confirmationLink}}',
    },
    {
      text: 'Reschedule link',
      type: 'menuitem',
      value: '{{appointment.rescheduleLink}}',
    },
    {
      text: 'Virtual appointment link',
      type: 'menuitem',
      value: '{{appointment.virtualLink}}',
    },
    {
      text: 'Appointment office name',
      type: 'menuitem',
      value: '{{appointment.location.name}}',
    },
    {
      text: 'Appointment office division name',
      type: 'menuitem',
      value: '{{appointment.location.division_name}}',
    },
    {
      text: 'Appointment office phone',
      type: 'menuitem',
      value: '{{appointment.location.phone}}',
    },
    {
      text: 'Appointment office address',
      type: 'menuitem',
      value: '{{appointment.location.address}}',
    },
    {
      text: 'Medical form link',
      type: 'menuitem',
      // should it be on patient object???
      value: '{{medicalFormLink}}',
    },
  ],
  txs_status_update: [
    {
      text: 'Patient first name',
      type: 'menuitem',
      value: '{{patient.firstName}}',
    },
    {
      text: 'Patient last name',
      type: 'menuitem',
      value: '{{patient.lastName}}',
    },
    {
      text: 'Medical form link',
      type: 'menuitem',
      // should it be on patient object???
      value: '{{medicalFormLink}}',
    },
    {
      text: 'Case closer link',
      type: 'menuitem',
      // should it be on patient object???
      value: '{{caseCloserLink}}',
    },
  ],
})

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let event_type = useDataValue({
    context: 'automation',
    path: 'event_type',
    viewPath: props.viewPath,
  })

  return useMemo(
    () =>
      event_type in MERGE_TAGS
        ? { ...data, items: MERGE_TAGS[event_type] }
        : null,
    [data, event_type]
  )
}
